import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Box,
  IconButton,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import {
  Fab
} from "@mui/material";
import { red } from "@mui/material/colors";

import { Mic, Send } from "@mui/icons-material";
import { tenant } from "../../utils/utils";
import ChatIcon from "@mui/icons-material/Chat";
const ChatBotMaterial = () => {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [typing, setTyping] = useState(false);
  const [lastInputByVoice, setLastInputByVoice] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  const chatBodyRef = useRef(null);

  useEffect(() => {
    chatBodyRef.current?.scrollTo({ top: chatBodyRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, typing]);

  const handleVoiceClick = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) return alert("Voice recognition not supported");

    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      setText(transcript);
      setLastInputByVoice(true);
      handleSend(transcript);
    };
    recognition.onerror = (event) => console.error("Voice recognition error:", event.error);

    recognition.start();
  };

  const handleSend = async (msgText) => {
    const userText = msgText || text;
    if (!userText.trim()) return;

    setMessages((prev) => [...prev, { from: "user", text: userText }]);
    setText("");
    setTyping(true);

    const typingMsg = { from: "bot", text: "typing..." };
    setMessages((prev) => [...prev, typingMsg]);

    try {
      const res = await fetch("https://chatbotpj.evyoog.com/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message:
            userText +
            " board on " +
            localStorage.getItem("board"),
          schema: tenant().replaceAll("ticket_", "") + "tem",
        }),
      });
      const data = await res.json();
      setTyping(false);
      setMessages((prev) => prev.filter((m) => m.text !== "typing..."));

      if (data?.answer) {
        if (lastInputByVoice) {
          playBotAudio(data.answer);
          setLastInputByVoice(false);
        } else {
          setMessages((prev) => [...prev, { from: "bot", text: data.answer.replace(`board ${localStorage.getItem("board")}`,"current board"), }]);
        }
      } else {
        setMessages((prev) => [...prev, { from: "bot", text: "No response from server" }]);
      }
    } catch (err) {
      console.error(err);
      setTyping(false);
      setMessages((prev) => [...prev, { from: "bot", text: "Error connecting to server" }]);
    }
  };

  const playBotAudio = async (text) => {
    try {
      const res = await fetch("https://chatbot.evyoog.com/speak", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text }),
      });
      const data = await res.json();
      if (data.audio_url) {
        if (currentAudio) currentAudio.pause();
        const audio = new Audio("https://chatbot.evyoog.com" + data.audio_url);
        audio.play().catch(console.error);
        setCurrentAudio(audio);
        setMessages((prev) => [...prev, { from: "bot", text }]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
    <Fab
                variant="extended"
                
                size="large"
                color="primary"
                        onClick={() => setOpen(true)}
                sx={{
                  color: "white",
                  fontSize: "10px",
                  fontFamily: "Arial, sans-serif",
                  position: "fixed", // Makes the button fixed on the screen
                  bottom: "4%", // Distance from the bottom of the screen
                  left: 16, // Distance from the right side of the screen
                  zIndex: 1000, // Ensures it appears above other elements
                }}>
                  <ChatIcon />
                  </Fab>
                  

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95vw", md: "80vw" },
            height: { xs: "90vh", md: "80vh" },
            bgcolor: "#f8f9fa",
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            boxShadow: 24,
            p: 2,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: "primary.main",
              color: "white",
              px: 3,
              py: 1.5,
              borderRadius: 2,
            }}
          >
            <Typography variant="h6">Assistant Chat </Typography>
            <IconButton onClick={() => setOpen(false)} sx={{ color: "white" }}>
              &times;
            </IconButton>
          </Box>

          {/* Chat body */}
          <Box
            ref={chatBodyRef}
            sx={{
              flex: 1,
              overflowY: "auto",
              p: 2,
              mt: 1,
              borderRadius: 2,
              bgcolor: "#e9ecef",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {messages.map((m, i) => (
              <Box
                key={i}
                sx={{
                  alignSelf: m.from === "user" ? "flex-end" : "flex-start",
                  bgcolor: m.from === "user" ? "primary.main" : "white",
                  color: m.from === "user" ? "white" : "black",
                  px: 2,
                  py: 1,
                  borderRadius: 3,
                  maxWidth: "70%",
                  fontStyle: m.from === "bot" ? "italic" : "normal",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  whiteSpace: "pre-line", // <<< preserves \n as new lines
                }}
              >
                {m.text === "typing..." ? (
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <CircularProgress size={12} />
                    <CircularProgress size={12} sx={{ animationDelay: "0.2s" }} />
                    <CircularProgress size={12} sx={{ animationDelay: "0.4s" }} />
                  </Box>
                ) : (
                  m.text
                )}
              </Box>
            ))}
          </Box>

          {/* Input */}
          <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Type your message..."
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSend()}
            />
            <IconButton color="success" onClick={handleVoiceClick}>
              <Mic />
            </IconButton>
            <IconButton color="primary" onClick={() => handleSend()}>
              <Send />
            </IconButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default ChatBotMaterial;
